// extracted by css-extract-rspack-plugin
export default {"settingsTable":"settingsTable-ZSnJkd","toggleWrapper":"toggleWrapper-do9BB7","inheritCheckbox":"inheritCheckbox-XirZpK","securityCheckTh":"securityCheckTh-PYiEUn"};